import { z } from 'zod';

/**
 * De API volgt de Laravel-conventie: één resource in `data`, lijsten met
 * `data` + `meta`. Deze helpers parsen dat met zod, zodat een wijziging in de
 * API meteen opvalt in plaats van halverwege een scherm.
 */
export const paginationMetaSchema = z.object({
    current_page: z.number(),
    last_page: z.number(),
    per_page: z.number(),
    total: z.number(),
});

export type PaginationMeta = z.infer<typeof paginationMetaSchema>;

export function dataEnvelope<T extends z.ZodTypeAny>(schema: T) {
    return z.object({ data: schema });
}

export function collectionEnvelope<T extends z.ZodTypeAny>(schema: T) {
    return z.object({
        data: z.array(schema),
        meta: paginationMetaSchema.optional(),
    });
}

export interface Page<T> {
    items: T[];
    meta: PaginationMeta | null;
}

export function unwrap<T extends z.ZodTypeAny>(schema: T, payload: unknown): z.infer<T> {
    const parsed = dataEnvelope(schema).parse(payload) as { data: z.infer<T> };

    return parsed.data;
}

export function unwrapCollection<T extends z.ZodTypeAny>(
    schema: T,
    payload: unknown,
): Page<z.infer<T>> {
    const parsed = collectionEnvelope(schema).parse(payload) as {
        data: Array<z.infer<T>>;
        meta?: PaginationMeta;
    };

    return { items: parsed.data, meta: parsed.meta ?? null };
}
